<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form inline class="inline-form">
          <el-form-item label="更新时间">
            <el-date-picker
              ref="creatTime"
              v-model="creatTime"
              type="datetimerange"
              align="left"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-select
              class="search-input"
              v-model="merchantId"
              placeholder="模糊搜索"
              clearable
              filterable
              :filter-method="handleMerchantInfoFilter">
              <el-option
                v-for="(item, index) in subMerchantNamesList"
                :key="index"
                :label="item.code"
                :value="item.code">
                <span class="value">{{ item.code }}</span>
                <span class="name">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
            <auth-button
              opt="export"
              :plain="true"
              icon="el-icon-download"
              :loading="exportButtonLoading"
              @click.native="exportClick"
              label="导出"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
      <p style="font-size: 14px; margin-bottom: 14px">说明：目前查询仅展示最近3个月数据</p>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- table -->
      <el-table
        stripe
        style="width:100%;"
        v-loading="tableLoading"
        :data="accountInquiryList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="fupdateTime"
          label="更新时间"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="fMerchantId"
          label="商户编号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="fMerchantName"
          label="商户简称"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="totalAmount"
          label="总计"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <div>{{ Number(scope.row.totalAmount / 100).toFixed(2) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="waitForCreate"
          label="待生成打款单金额"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <div>{{ Number(scope.row.waitForCreate / 100).toFixed(2) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="已生成打款单金额"
          align="center"
          min-width="150">
          <el-table-column
            prop="nowOrderReport"
            label="打款中"
            align="center"
            min-width="150">
            <template slot-scope="scope">
              <div>{{ Number(scope.row.nowOrderReport / 100).toFixed(2) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="fOrderAmount"
            label="打款失败"
            align="center"
            min-width="150">
            <template slot-scope="scope">
              <div>{{ Number(scope.row.orderPayFailure / 100).toFixed(2) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="fOrderAmount"
            label="打款退票"
            align="center"
            min-width="150">
            <template slot-scope="scope">
              <div>{{ Number(scope.row.orderPayRefund / 100).toFixed(2) }}</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="stopAmount"
          label="止付金额"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <div>{{ Number(scope.row.stopAmount / 100).toFixed(2) }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.count > 0"
        class="pagination"
        :page-size="paginations.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="paginations.count"
        :current-page="paginations.pageNo"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import qs from 'qs'
import { parseTime } from '@/utils/formatTime'
import { getAllSubMerchantNames, listAccount, exportMerchantAccount } from '@/api/settle.js'

export default {
  name: 'AccountInquiry',
  data () {
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10) + ' 23:59:59'
    const toadyZero = new Date(new Date().getTime() - 3600 * 1000 * 24 * 30 * 3)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10) + ' 00:00:00'
    return {
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6 || time.getTime() < Date.now() - 3600 * 1000 * 24 * 30 * 3 - 3600 * 1000 * 24
        },
        // onPick({ maxDate, minDate }) {
        //   if (maxDate && minDate && maxDate.getTime() - minDate.getTime() > 3600 * 1000 * 24 * 30) {
        //     this.$message({
        //       message: '请筛选1个月内的交易进行查询',
        //       type: 'error'
        //     })
        //   }
        // },
        shortcuts: [{
          text: '昨天',
          onClick (picker) {
            // 精确到日
            const start = new Date()
            start.setHours(0)
            start.setMinutes(0)
            start.setSeconds(0)
            const end = new Date()
            end.setHours(23)
            end.setMinutes(59)
            end.setSeconds(59)
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        merchantId: ''
      },
      creatTime: [todayZeroStr, todayStr],
      merchantId: '',
      tableLoading: false,
      exportButtonLoading: false,
      subMerchantNamesList: [],
      subMerchantNamesList_back: [],
      accountInquiryList: []
    }
  },
  mounted () {
    this.getDefaultData()
  },
  beforeDestroy () {},
  methods: {
    /**
     * @description 初始加载数据方法
     */
    async getDefaultData () {
      // this.loading = true
      await Promise.all([this.getAllSubMerchantNames(), this.searchClick()])
      this.loading = false
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * @description 筛选查询按钮点击
     */
    searchClick (noReset) {
      console.log('查询点击')
      if (!this.setSearchInfoParams(noReset)) return
      this.listAccount()
    },
    /**
     * 导出按钮点击
     */
    exportClick () {
      console.log('导出点击')
      if (!this.setSearchInfoParams(true)) return
      const startDate = new Date(this.searchInfo.startTime)
      const endDate = new Date(this.searchInfo.endTime)
      if (!this.searchInfo.startTime || !this.searchInfo.endTime || endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 30) {
        this.$message({
          message: '请筛选1个月内的数据进行导出',
          type: 'error'
        })
        return
      }
      this.exportMerchantAccount()
    },
    /**
     * 组装筛选参数
     */
    setSearchInfoParams (noReset) {
      if (!this.creatTime || this.creatTime.length === 0) {
        this.$message({
          message: '请选择筛选时间',
          type: 'error'
        })
        return false
      }
      this.searchInfo.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.searchInfo.merchantId = this.merchantId.replace(/ /g, '') || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      Object.assign(this.searchInfo, this.paginations)
      return true
    },
    dateChange (value) {
      if (value !== null) {
        if ((value[0] === value[1])) {
          value[0] = value[0].substring(0, 10) + ' 00:00:00'
          value[1] = value[1].substring(0, 10) + ' 23:59:59'
        }
      }
    },
    /**
     * @description 删除提交参数中的空字段
     * @param {Object} params 搜索内容对象
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 商户选择筛选商户方法
     */
    handleMerchantInfoFilter (queryString) {
      if (queryString) {
        this.subMerchantNamesList = this.subMerchantNamesList_back.filter(item => {
          return item.code.toLowerCase().includes(queryString.toLowerCase()) || item.name.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.subMerchantNamesList = this.subMerchantNamesList_back
      }
    },
    /**
     * @description 获取商户编号下拉列表
     */
    getAllSubMerchantNames () {
      return new Promise((resolve, reject) => {
        getAllSubMerchantNames('').then(response => {
          console.log('getAllSubMerchantNames response:', response)
          if (response.error_code === '0') {
            this.subMerchantNamesList = response.data
            this.subMerchantNamesList_back = [...this.subMerchantNamesList]
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
            resolve(false)
          }
        }).catch(err => {
          this.loading = false
          reject(err)
        })
      })
    },
    /**
     * 账户查询
     */
    listAccount () {
      // this.loading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      listAccount(params).then(response => {
        console.log('listAccount response:', response)
        this.loading = false
        if (response.error_code === '0') {
          this.accountInquiryList = response.data.list
          this.paginations.count = response.data.totalCount
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 账户查询导出
     */
    exportMerchantAccount () {
      this.exportButtonLoading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      exportMerchantAccount(params).then(response => {
        this.exportButtonLoading = false
        console.log('exportMerchantAccount调用')
        // 弹出下载框
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '账户信息.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }, {
        axios_opts: {
          responseType: 'blob'
        }
      })
    },
    formatDate (item) {
      return parseTime(new Date(item.fTime), '{y}-{m}-{d} {h}:{i}:{s}')
    }
  },
  computed: {},
  filters: {}
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
</style>
